import React from 'react';
import { ListGroupItem } from 'reactstrap';
import styled from 'styled-components';

// sorts an array of dates
const sortDates = (arrayOfDates) => {
  return arrayOfDates.sort((a, b) => {
    // Turn your strings into dates, and then subtract them
    // to get a value that is either negative, positive, or zero.
    return new Date(a.date) - new Date(b.date);
  });
};

const sortByLastName = (arrayOfObjects) => {
  const alphabetical = arrayOfObjects.sort((a, b) => {
    if (a.lastName < b.lastName) {
      return -1;
    }
    if (a.lastName > b.lastName) {
      return 1;
    }
    return 0;
  });
  return alphabetical;
};

// inserts new date into EXISTING sorted array in the correct place from earliest date to latest
const insertDate = (array, itemToBeInserted) => {
  const newArray = array.slice();
  for (let i in newArray) {
    if (new Date(newArray[i].date).getTime() > new Date(itemToBeInserted.date).getTime()) {
      newArray.splice(i, 0, itemToBeInserted);
      return newArray;
    }
  }
  newArray.splice(newArray.length, 0, itemToBeInserted);
  return newArray;
};

const insertNumber = (array, numToBeInserted, indexToStartAt = 0) => {
  const newArray = array.slice();
  for (let i = indexToStartAt; i < array.length; i++) {
    if (newArray[i] > numToBeInserted) {
      newArray.splice(i, 0, numToBeInserted);
      return newArray;
    }
  }
  newArray.splice(newArray.length, 0, numToBeInserted);
  return newArray;
};

// adds the correct suffix to a number (i.e. 1st, 2nd, 3rd, 4th)
const ordinal_suffix_of = (i) => {
  var j = i % 10,
    k = i % 100;
  if (j == 1 && k != 11) {
    return `${i}st`;
  }
  if (j == 2 && k != 12) {
    return `${i}nd`;
  }
  if (j == 3 && k != 13) {
    return `${i}rd`;
  }
  return `${i}th`;
};

export {
  // SortableItem, SortableList,
  ordinal_suffix_of,
  insertDate,
  sortDates,
  insertNumber,
  sortByLastName,
};
